import React, { useContext } from 'react'
import { Moment, SocialSharing, Loading, GlobalContext, I18NConsumer } from 'commons'
import { setPageTitle, clientTimeZone, baseUrl } from 'utils'
import NoResult from 'containers/notification-center/NoResult'
import PropTypes from 'prop-types';
import RtfContent from '../general-notification/detail/RtfContent'
import AttachmentImages from '../general-notification/detail/AttachmentImages'
import AttachmentList from '../general-notification/detail/AttachmentList'

import CommsHeader from './CommsHeader'

const CommunicationDetail = () => {
  const {
    account: { timeZone },
    organization: { showNotificationsToMemberPortalSocialSharing, isPublic },
    commsData: {
      commsId: id,
      title,
      message: rtfContent,
      attachmentFiles,
      sendDate: date,
      priority,
      textMessage = '',
    },
  } = useContext(GlobalContext)

  if (!id) {
    return <Loading />
  }

  const noResult = !textMessage && !rtfContent && (!attachmentFiles || attachmentFiles.length === 0)

  return (
    <div className="notification-detail">
      <I18NConsumer>
        {() => setPageTitle(`${title}`)}
      </I18NConsumer>
      <CommsHeader {...{ priority, id, title }} />
      <div className="col-sm-12 date">
        <p>
          <Moment
            tz={timeZone || clientTimeZone}
            format="YYYY-MM-DD HH:mm:ss z"
            eb-test="ee_notificationDetail_text_datetime"
          >
            {date}
          </Moment>
        </p>
        {isPublic && showNotificationsToMemberPortalSocialSharing && (
          <SocialSharing
            url={`${baseUrl}/comms/${id}`}
            title={title}
            description={textMessage}
            eb-test="ee_notificationDetail_field_shareButtons"
          />
        )}
      </div>
      {noResult && <NoResult message="general.notification.noneProvided" />}
      <div className="row">
        <div className="col">
          {rtfContent && <RtfContent {...{ title, rtfContent }} />}
          {attachmentFiles &&
                <AttachmentImages images={attachmentFiles.filter((file) => file.image)} />
          }
          {attachmentFiles && <AttachmentList files={attachmentFiles} />}
        </div>
      </div>
    </div>
  )
}

CommunicationDetail.propTypes = {
  i18n: PropTypes.shape({
    'notification.title.text': PropTypes.string.isRequired,
  }).isRequired,
  organization: PropTypes.shape({
    orgName: PropTypes.string.isRequired,
  }).isRequired,
  commsData: PropTypes.shape({
    commsId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    attachmentFiles: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.bool,
        fileId: PropTypes.string.isRequired,
        fileName: PropTypes.string.isRequired,
      })
    ),
    sendDate: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
    textMessage: PropTypes.string,
  }).isRequired,
};

export default CommunicationDetail
